module.exports = __webpack_public_path__ + "/login_ui/img/ng-a76a7b68b4952c0bdb13a8d367c38fcf.svg";